import React from 'react';
import { Visibility, Mouse } from '@material-ui/icons';
import {
    StyledContainer,
    SectionName, 
    SectionTitle,
    SectionDescription
} from '../../Home.styles';
import { ItemTitle, ItemDescription, ItemIcon} from '../OurOffer/OurOffer.styles';
import { StyledFlexWrapper } from './WhatNext.styles';

export function WhatNext() {
    return (
        <StyledContainer>
            <SectionName>what's next</SectionName>
            <SectionTitle>Check what works best for your business!</SectionTitle>
            <SectionDescription>
                Have access to each ad campaign statistics and be armed with the relevant metrics to increase brand awareness and expand your online presence. 
                <br/><br/>
                Impression and engagement counters capture data regarding frequency of user interaction with your products and services advertisements. 
                <br/><br/>
                Statistical and analytical reports can be generated from the captured data based on predetermined interval duration. 
                <br/><br/>
                For each type of ad campaign, the following user actions may be captured:
            </SectionDescription>
            <StyledFlexWrapper>
                <ItemIcon backgroundColor="#5cc0e826" iconColor="#5CC0E8">
                    <Visibility />
                </ItemIcon>
                <div>
                    <ItemTitle>Impressions (Views)</ItemTitle>
                    <ItemDescription>
                        A counter that measures how many times your ads were viewed by the users.
                    </ItemDescription>    
                </div>
                
            </StyledFlexWrapper>
            <StyledFlexWrapper>
                <ItemIcon backgroundColor="#f7b50026" iconColor="#F7B500">
                    <Mouse />
                </ItemIcon>
                <div>
                    <ItemTitle>Engagements (Clicks)</ItemTitle>
                    <ItemDescription>
                        A counter that measures the number of times users clicked/interacted with your ads.
                    </ItemDescription>
                </div>
            </StyledFlexWrapper>
        </StyledContainer>
    )
}
